import { RadioGroup as KobalteRadioGroup } from "@kobalte/core/radio-group"
import type { AccentHue } from "@repo/fika-design-system/color"
import type { JSX } from "solid-js"
import { For, Show } from "solid-js"
import {
  radioGroupClass,
  radioGroupClassHorizontal,
  radioGroupItemControlRecipe,
  radioGroupItemDescriptionClass,
  radioGroupItemIndicatorClass,
  radioGroupItemInputClass,
  radioGroupItemLabelClass,
  radioGroupItemLabelContainerClass,
  radioGroupItemRecipe,
  radioGroupItemRowClass,
  radioGroupSelectedContentClass,
} from "./radio-group.css"

export interface RadioGroupOption {
  value: string
  label: string
  description?: string
  disabled?: boolean
  children?: () => JSX.Element
}

interface RadioGroupProps {
  value: string
  onChange: (value: string) => void
  options: RadioGroupOption[]
  orientation?: "horizontal" | "vertical"
  disabled?: boolean
  hue?: AccentHue
}

export function RadioGroup(props: RadioGroupProps) {
  const orientation = () => props.orientation ?? "vertical"

  return (
    <KobalteRadioGroup
      value={props.value}
      onChange={props.onChange}
      orientation={orientation()}
      disabled={props.disabled}
      class={`${radioGroupClass} ${orientation() === "horizontal" ? radioGroupClassHorizontal : ""}`.trim()}
    >
      <For each={props.options}>
        {option => (
          <KobalteRadioGroup.Item
            value={option.value}
            disabled={option.disabled}
            class={radioGroupItemRecipe({ hue: props.hue })}
            onClick={e => {
              if (
                (e.target as HTMLElement).closest?.("[data-selected-content]")
              )
                return
              props.onChange(option.value)
            }}
          >
            <div class={radioGroupItemRowClass}>
              <div class={radioGroupItemLabelContainerClass}>
                <KobalteRadioGroup.ItemLabel class={radioGroupItemLabelClass}>
                  {option.label}
                </KobalteRadioGroup.ItemLabel>
                <Show when={option.description}>
                  <KobalteRadioGroup.ItemDescription
                    class={radioGroupItemDescriptionClass}
                  >
                    {option.description}
                  </KobalteRadioGroup.ItemDescription>
                </Show>
              </div>
              <KobalteRadioGroup.ItemInput class={radioGroupItemInputClass} />
              <KobalteRadioGroup.ItemControl
                class={radioGroupItemControlRecipe({ hue: props.hue })}
              >
                <KobalteRadioGroup.ItemIndicator
                  class={radioGroupItemIndicatorClass}
                />
              </KobalteRadioGroup.ItemControl>
            </div>
            {option.children ? (
              <div
                class={radioGroupSelectedContentClass}
                data-selected-content
                data-expanded={props.value === option.value}
              >
                {option.children()}
              </div>
            ) : null}
          </KobalteRadioGroup.Item>
        )}
      </For>
    </KobalteRadioGroup>
  )
}
